import { FormControlLabel, Stack, Switch, Tooltip, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import PropTypes from 'prop-types';

function RpSwitchFilter(props) {
    return (
        <Stack spacing={1} sx={{
            '& .MuiFormControlLabel-root': {
                justifyContent: 'space-between',
            },
            ...props.sx,
        }}>
            <FormControlLabel
                control={
                    <Switch
                        checked={props.value}
                        onChange={e => props.onChange(e.target.checked)}
                        color="primary"
                    />
                }
                label={
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                        <Typography variant="text1" sx={{mb: '0 !important'}}>{props.label}</Typography>
                        {props.tooltip && (
                            <Tooltip
                                title={props.tooltip}
                                slotProps={{
                                    tooltip: {
                                        sx: {
                                            maxWidth: 240,
                                            lineHeight: 1.5,
                                            fontSize: '11px',
                                            padding: 1.5,
                                        }
                                    },
                                }}
                                arrow
                                placement="top"
                            >
                                <span tabIndex={0} style={{display: 'flex', alignItems: 'center'}}>
                                    <InfoIcon fontSize="small" sx={{color: 'action.active'}}/>
                                </span>
                            </Tooltip>
                        )}
                    </Stack>
                }
                labelPlacement="top"
                sx={{
                    flexDirection: 'row-reverse',
                    fontSize: '13px',
                }}
            />
        </Stack>
    );
}

RpSwitchFilter.propTypes = {
    value: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    tooltip: PropTypes.string,
    label: PropTypes.string.isRequired,
};

export default RpSwitchFilter;